export default __webpack_public_path__ + "static/media/MOTIVO_15.72730cd7.jpg";